import React from "react";
import { Nav } from "../components/site/Nav.jsx";
import { Hero } from "../components/site/Hero.jsx";
import { Engines } from "../components/site/Engines.jsx";
import { AutoTrade } from "../components/site/AutoTrade.jsx";
import { NewsImpact } from "../components/site/NewsImpact.jsx";
import { Performance } from "../components/site/Performance.jsx";
import { TerminalSection } from "../components/site/Terminal.jsx";
import { CTA, Footer } from "../components/site/CTA.jsx";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Nav />
      <main>
        <Hero />
        <Engines />
        <AutoTrade />
        <NewsImpact />
        <Performance />
        <TerminalSection />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
